import React from 'react';
import {Flex} from '/app/src/component';
import Header from "./Header"

const bodyTextStyle = {
    fontSize: "20px",
    color: "Black_M",
}

const bodyTextWrapper = {
    width: "50%"
}

const bottomTextStyle = {
    hAlignContent: "center",
    margin: "20px 0px"
}

const imgContainer = {
    maxWidth: "300px",
    marginLeft: "20px",
    height: "350px"
}

const bodyContainer = {
    marginTop: "30px",
    hAlignContent: "center"
}



const HelpdeskUpgrade = () => (
    <Flex column  hAlignContent="center" >
        <Flex>
            <Header
                icon={"/images/Menu_ClientChat_Helpdesk_L.svg"}
                text={"Du har upptäckt en Pro-funktion!"}/>
        </Flex>
        <Flex {...bodyContainer} grow>
            <Flex {...bodyTextStyle} {...bodyTextWrapper}>
                Med helpdesk får du tillgång att skapa en komplett kunskapsbank med
                lättnavigerade kategorier och stylade artikelsidor. Dessutom ingår
                ett system för att ta emot feedback från besökarna, så att ni kan
                hålla frågorna optimerade.
            </Flex>
            <Flex>
                <img style={imgContainer} src="/images/PriceplanGraphic_Helpdesk.png" alt=""/>
            </Flex>
        </Flex>
        <Flex {...bodyTextStyle} {...bottomTextStyle}>
            Kom igång direkt och avlasta er kundtjänst!
        </Flex>
    </Flex>
)

export default HelpdeskUpgrade;



// WEBPACK FOOTER //
// ./src/component/Modal/UpgradeModal/HelpdeskUpgrade.js